import React from 'react';
import {t} from 'ttag';
import {Box, Typography} from '@mui/material';
import {getCountryName} from '@invoice-system/components/helpers/countryCode';

interface InvoiceReceiptProps {
  data: any;
}

export const InvoiceReceipt = ({data}: InvoiceReceiptProps) => {
  return (
    <Box display={'flex'} flexDirection={'column'} mt={1} gap={1}>
      <Typography variant={'body2'} textTransform={'capitalize'} color={'black'} textAlign={{xs: 'left', md: 'right'}}>
        {data?.billingName?.toLowerCase() || t`Billing name not present`}
      </Typography>
      <Typography variant={'body2'} color={'black'} textAlign={{xs: 'left', md: 'right'}}>
        {data?.email || t`Email not present`}
      </Typography>
      <Typography variant={'body2'} textTransform={'capitalize'} color={'black'} textAlign={{xs: 'left', md: 'right'}}>
        {getCountryName(data?.country) || t`Country not present`}
      </Typography>
      <Typography variant={'body2'} textTransform={'capitalize'} color={'black'} textAlign={{xs: 'left', md: 'right'}}>
        {data?.address?.toLowerCase() || t`Address not present`}
      </Typography>
      <Typography variant={'body2'} textTransform={'capitalize'} color={'black'} textAlign={{xs: 'left', md: 'right'}}>
        {(data?.city?.toLowerCase() || t`City not present`) + ', ' + (data?.postalCode || 'N/A')}
      </Typography>
      <Typography variant={'body2'} color={'black'} textAlign={{xs: 'left', md: 'right'}}>
        {t`Tax ID` + `: ${data?.taxId || 'N/A'}`}
      </Typography>
      {/*<Typography variant={'body2'} color={'black'} textAlign={{xs: 'left', md: 'right'}}>
        {t`Phone` + `: ${data?.phone}`}
      </Typography>*/}
    </Box>
  );
};
